module.exports = {
  key: "e4a17961fba41a74dd587fda4ffcd0b2",
  base: "https://api.openweathermap.org/data/2.5/",
};
